const AMBEV = 'ambev';
const BNDES = 'bndes';
const CAPITAL_GIRO = 'capital-giro';
const ESTIMULO = 'estimulo';
const ESTIMULO_2020 = 'estimulo2020';
const ESTIMULO_2020_BR = 'estimulo2020_br';
const ESTIMULO_2020_RS = 'estimulo2020_rs';
const ESTIMULO_2020_RECEIVABLES = 'estimulo2020_recebiveis';
const SEBRAE = 'sebrae';
const POLIGONO = 'poligono'; // TODO: substituir pelo bizId real quando o backend definir

export {
    CAPITAL_GIRO,
    ESTIMULO,
    ESTIMULO_2020,
    ESTIMULO_2020_BR,
    ESTIMULO_2020_RS,
    ESTIMULO_2020_RECEIVABLES,
    AMBEV,
    BNDES,
    SEBRAE,
    POLIGONO,
};
